export interface OrderDeliveryInfo {
  id: number;
  deliveryStatus: OrderDeliveryInfoStatus;
  pickupAddress: OrderDeliveryInfoAddress;
  pickupInstructions: string;
  dropOffAddress: OrderDeliveryInfoAddress;
  dropoffInstructions: string;
  quotedPickupTime: string;
  actualPickupTime: string;
  quotedDeliveryTime: string;
  actualDeliveryTime: string;
  orderValue: number;
  customer: {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
  };
  courier: {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    location: {
      lat: number;
      lng: number;
    };
  };
  deliveryTrackingUrl: string;
}

export interface OrderDeliveryInfoAddress {
  addressLine1: string;
  addressLine2: string;
  locality: string;
  administrativeArea: string;
  postalCode: string;
  longitude?: number;
  latitude?: number;
}

export enum OrderDeliveryInfoStatus {
  Unknown = 'Unknown',
  Scheduled = 'Scheduled',
  Assigned = 'Assigned',
  PickedUp = 'PickedUp',
  Delivered = 'Delivered',
  Cancelled = 'Cancelled',
  EnroutePickup = 'EnroutePickup',
  EnrouteDropoff = 'EnrouteDropoff',
  Arrived = 'Arrived',
}

export enum DeliveryErrorCode {
  ValidationException = 'DLV-0001',
  EntreecountCannotBeNegative = 'DLV-0003',
  OrdervalueCannotBeNegative = 'DLV-0004',
  OrderidIsRequired = 'DLV-0010',
  PickupPhonenumberIsInvalid = 'DLV-0014',
  ItemCountIsInvalid = 'DLV-0015',
  DropoffAddressIsRequired = 'DLV-0020',
  DropoffAddressLine1IsRequired = 'DLV-0021',
  DropoffAddressCityIsRequired = 'DLV-0023',
  DropoffAddressStateIsRequired = 'DLV-0024',
  DropoffAddressZipcodeIsRequired = 'DLV-0025',
  PickupAddressIsRequired = 'DLV-0030',
  PickupAddressLine1IsRequired = 'DLV-0031',
  PickupAddressCityIsRequired = 'DLV-0033',
  PickupAddressStateIsRequired = 'DLV-0034',
  PickupAddressZipcodeIsRequired = 'DLV-0035',
  CustomerIsRequired = 'DLV-0050',
  CustomerFirstnameIsRequired = 'DLV-0051',
  CustomerEmailIsRequired = 'DLV-0052',
  CustomerPhonenumberIsInvalid = 'DLV-0053',
  DropoffAddressOutofRange = 'DLV-1000',
  DropoffAddressResturantClosed = 'DLV-1002',
}

export function errorMap(errorCode: string): string {
  switch (errorCode) {
    case 'DLV-1002':
    case 'DLV-1005':
    case 'DLV-1007':
      return `Sorry we are not delivering at this time. <br> Try again or switch to pickup.`;

    case 'DLV-1000':
    case 'DLV-1001':
    case 'DLV-1003':
    case 'DLV-1004':
    case 'DLV-1006':
    default:
      return `Sorry we can't deliver to this address. <br> Try again or switch to pickup.`;
  }
}

export interface DeliveryApiError {
  errorCode: DeliveryErrorCode;
  errorData: null;
  errorDescription: string;
}

export interface DeliveryApiValidationError {
  errorCode: DeliveryErrorCode;
  message: string;
  name: string;
}

export class DeliveryApiException extends Error {
  constructor(public errors: DeliveryApiError[]) {
    super();
  }
}

export class DeliveryNotAvailableInThatCountryException extends Error {}
